<template>
  <div class="WMap">
    <CallHelpTel />
    <div class="container">
      <div class="title">
        <div class="yellow"></div>
        <div class="article_T">
          <h3 :style="{ fontSize: fontSize.h4 + 'em' }">著作權聲明</h3>
        </div>
      </div>
      <div class="privacy_content">
        <div class="content_wrap">
          <div class="content_title">
            <h4 class="sec_title" :style="{ fontSize: fontSize.h5 + 'em' }">
              以下為著作權聲明資訊
            </h4>
          </div>
          <!-- <div class="content_item">
            <div class="inside_title">
              <h5 :style="{ fontSize: fontSize.h5 + 'em' }"></h5>
            </div>
            <p :style="{ fontSize: fontSize.p + 'em' }">
            </p>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { inject } from "vue";
import CallHelpTel from "../components/Home/CallHelpTel.vue";

export default {
  components: {
    CallHelpTel,
  },
  setup() {
    //  無障礙文字子層引入設定
    let fontSize = inject("fontSize");
    return {
      fontSize,
    };
  },
};
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  display: flex;
  .yellow {
    width: 3%;
    background-color: $main_sec_color;
  }
  .article_T {
    width: 100%;
    background-color: $main_color;
    padding: 20px;
    @include md {
      h3 {
        font-size: $p;
      }
    }
    h3 {
      color: #fff;
      text-align-last: left;
      margin-bottom: 0;
    }
  }
}
.content_wrap {
  width: 60%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  .content_title {
    margin: 15px 0;
    .sec_title {
      text-align: left;
      font-weight: 600;
    }
  }
  .content_item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 30px;
    .inside_title {
      margin-bottom: 10px;
      border-bottom: 3px dotted $main_color;
    }
    h5 {
      text-align: left;
    }
    P {
      text-align: left;
    }
  }
}
</style>
